// src/contexts/ProFeatureContext.js
import React, { createContext, useState, useContext } from 'react';
import ProFeatureNotification from '../components/ProFeatureNotification';

// Create context
const ProFeatureContext = createContext();

// Create provider
export const ProFeatureProvider = ({ children, onUpgradeClick }) => {
  const [notification, setNotification] = useState(null);
  
  // Function to show pro feature notification
  const showProFeatureNotification = (message) => {
    setNotification(message);
    
    // Automatically clear notification after it animates out (4 seconds)
    setTimeout(() => {
      setNotification(null);
    }, 4000);
  };
  
  return (
    <ProFeatureContext.Provider value={{ showProFeatureNotification }}>
      {children}
      
      {notification && (
        <ProFeatureNotification 
          message={notification} 
          onUpgradeClick={onUpgradeClick}
        />
      )}
    </ProFeatureContext.Provider>
  );
};

// Custom hook to use this context
export const useProFeature = () => {
  const context = useContext(ProFeatureContext);
  if (!context) {
    throw new Error('useProFeature must be used within a ProFeatureProvider');
  }
  return context;
};